import { useSelector } from "react-redux";
import { RootState } from "store";
import {
  RoleCode,
  ROLE_HIERARCHY,
} from "features/RolesAndPermissions/constants/role.constants";

export const useProfile = () => {
  const loginState = useSelector((state: RootState) => state.auth);

  const isYou = (id: number) => loginState.user?.id === id;

  const roles = loginState.user?.roles ?? [];

  const isEmployee =
    !!roles.some((r) => r.code === RoleCode.EMPLOYEE) &&
    !!loginState.user?.employee;

  const isSuperAdmin = !!roles.some((r) => r.code === RoleCode.SUPER_ADMIN);
  const isHR = !!roles.some((r) => r.code === RoleCode.HR);
  const isMarketing = !!roles.some((r) => r.code === RoleCode.MARKETING);

  // Any user with an employee record can clock in (regardless of role)
  const hasEmployeeRecord = !!loginState.user?.employee;

  const highestRole = roles.length
    ? [...roles].sort(
        (a, b) =>
          (ROLE_HIERARCHY[b.code as RoleCode] ?? 0) -
          (ROLE_HIERARCHY[a.code as RoleCode] ?? 0),
      )[0]
    : null;

  return {
    user: loginState.user,
    permissions: loginState.permissions,
    token: loginState.token,
    loading: loginState.loading,
    isAuthenticated: !!loginState.token && !!loginState.user,
    isEmployee,
    isSuperAdmin,
    isHR,
    isMarketing,
    hasEmployeeRecord,
    highestRole,
    isYou,
  };
};
